import React from "react";
import {
  TextField,
  Box,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

function FileSearchBar({ searchQuery, setSearchQuery, onSearch }) {
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search files..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={handleKeyPress}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={onSearch} edge="end">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "25px",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "25px",
          },
        }}
      />
    </Box>
  );
}

export default FileSearchBar;